var _style, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000132074569663538037080000003550682480781021849_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 29",
    style: {
      enableBackground: "new 0 0 29 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    y: 0,
    width: 29,
    height: 29
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "line-color",
    d: "M20.4,12c0.4-0.4,0.4-1,0-1.4l-2.1-2.1c-0.2-0.2-0.4-0.3-0.7-0.3c-0.3,0-0.5,0.1-0.7,0.3l-8.2,8.2 c-0.1,0.1-0.2,0.3-0.2,0.5l-0.4,2.6c-0.1,0.5,0.3,1,0.8,1c0,0,0.1,0,0.1,0l2.6-0.4c0.2,0,0.4-0.1,0.5-0.2L20.4,12z M11.7,19.7 C11.7,19.8,11.6,19.8,11.7,19.7l-2.5-2.4c0,0,0,0,0-0.1l7.2-7.2l2.5,2.5L11.7,19.7z M17.4,9c0.1-0.1,0.2-0.1,0.2-0.1 c0.1,0,0.1,0,0.2,0.1l2.1,2.1c0.1,0.1,0.1,0.3,0,0.4l-0.6,0.6l-2.5-2.5L17.4,9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.97cf0d50ca86ce66bf64c4598b55a0fc.svg";
export { ForwardRef as ReactComponent };